import type React from "react";

export const Fleuron: React.FC<{ className?: string }> = ({ className = "" }) => (
  <svg
    viewBox="0 0 40 12"
    aria-hidden="true"
    className={className}
    style={{ overflow: "visible" }}
  >
    <g fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round">
      <path d="M2 6 h12" />
      <path d="M26 6 h12" />
      <path d="M17 6 c1.5 -3 4.5 -3 6 0 c-1.5 3 -4.5 3 -6 0 z" fill="currentColor" />
      <circle cx="20" cy="6" r="0.9" fill="var(--parchment)" />
    </g>
  </svg>
);

export const Divider: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center gap-5 text-[color:var(--gilt-deep)] ${className}`}
    aria-hidden="true"
  >
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-[color:var(--gilt-hairline)] to-[color:var(--gilt-hairline)]" />
    <Fleuron className="w-10 h-3" />
    <span className="h-px flex-1 bg-gradient-to-l from-transparent via-[color:var(--gilt-hairline)] to-[color:var(--gilt-hairline)]" />
  </div>
);

export const CornerFlourish: React.FC<{ className?: string; flip?: boolean }> = ({
  className = "",
  flip = false,
}) => (
  <svg
    viewBox="0 0 60 60"
    aria-hidden="true"
    className={className}
    style={{ transform: flip ? "scaleX(-1)" : undefined }}
  >
    <g fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round">
      <path d="M2 2 L2 22 Q2 32 12 32 L32 32" />
      <path d="M2 2 L22 2 Q32 2 32 12 L32 24" />
      <circle cx="32" cy="32" r="2.2" fill="currentColor" />
      <path d="M32 32 Q44 32 44 44 Q44 52 36 52" />
      <circle cx="36" cy="52" r="1.5" fill="currentColor" />
    </g>
  </svg>
);

export const Monogram: React.FC<{ className?: string }> = ({ className = "" }) => (
  <span
    className={`relative inline-block font-wordmark leading-none align-middle ${className}`}
    style={{ width: "1.7em", height: "1.25em" }}
    aria-label="Moyle Manor"
  >
    <span
      className="absolute text-[color:var(--claret-deep)]"
      style={{ left: 0, top: "-0.18em" }}
      aria-hidden="true"
    >
      M
    </span>
    <span
      className="absolute text-[color:var(--claret-deep)]"
      style={{ left: "0.55em", top: "0.18em" }}
      aria-hidden="true"
    >
      M
    </span>
  </span>
);
